import Slider from './common/slider';
import Accordion from './common/accordion';
import ContactForm from './common/contact-form';
import Tab from './common/tabs';
import Select from './common/select';
import Poi from './components/poi/poi';
import TreasurybondsForm from './common/treasurybonds-form';
import ComparisionTable from './components/comparision-table/ComparisionTable';
import Search from './components/search/Search';
import Cookie from './common/cookie';
import PremiumSearch from './common/premium-search';
import HeroSlider from './components/hero-slider/HeroSlider';
import News from './components/news/news';
import AlertSnippet from './common/alerts/alert-snippet';
import HighContrast from './common/high-contrast';
import Navigation from './components/navigation/Navigation';
import VideoPlayer from './components/video-player/VideoPlayer';
import LoginModal from './common/login-modal';

class App {
    constructor() {
        this.init();
    }

    init() {
        new Poi();
        new ComparisionTable();
        new Search();
        new HeroSlider();
        new VideoPlayer();
        new Navigation();

        this.initGlobalModules();
    }

    initGlobalModules() {
        this.initAccordions();
        this.initContactForm();
        this.initTabs();
        this.initSelect();
        this.initTreasurybondsForm();
        this.initSlider();
        this.initCookie();
        this.initPremiumSearch();
        this.initNews();
        this.initAlertSnippet();
        this.initHighContrast();
        this.initLoginModal();
    }

    /**
     * Init global accordions
     */
    initAccordions() {
        const $containers = document.querySelectorAll('.accordions');

        if (!$containers) {
            return;
        }

        [...$containers].forEach(($container) => {
            [...$container.querySelectorAll('.accordions__item')].forEach(($item) => new Accordion($item));
        });
    }

    initContactForm() {
        const $contactForm = document.querySelector('#contact-form');

        if (!$contactForm) {
            return;
        }

        new ContactForm($contactForm);
    }

    initTabs() {
        const $containers = document.querySelectorAll('.tabs');

        if (!$containers) {
            return;
        }

        [...$containers].forEach(($container) => new Tab($container));
    }

    initSelect() {
        const $containers = document.querySelectorAll('.select-custom');

        if (!$containers) {
            return;
        }

        [...$containers].forEach(($select) => new Select($select));
    }

    initTreasurybondsForm() {
        const $treasurybondsForm = document.querySelector('.treasurybonds__form');

        if (!$treasurybondsForm) {
            return;
        }

        new TreasurybondsForm($treasurybondsForm);
    }

    initCookie() {
        const $cookie = document.querySelector('.cookie');

        if (!$cookie) {
            return;
        }

        new Cookie($cookie);
    }

    initPremiumSearch() {
        const $premiumSearch = document.querySelector('.premium-search');

        if (!$premiumSearch) {
            return;
        }

        new PremiumSearch($premiumSearch);
    }

    initNews() {
        const $news = document.querySelector('.news');

        if (!$news) {
            return;
        }

        new News($news);
    }

    initAlertSnippet() {
        const $alerts = document.querySelectorAll('.alert');

        if (!$alerts) {
            return;
        }

        [...$alerts].forEach(($item) => new AlertSnippet($item));
    }

    initSlider() {
        const $slider = document.querySelectorAll('.slider');

        if (!$slider) {
            return;
        }

        const $sliderParams = {};

        const $sliderMultipleParams = {
            infinite: true,
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }, {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                }, {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        };

        [...$slider].forEach(($item) => {
            if ($item.classList.contains('slider--multiple')) {
                new Slider($item, { ...$sliderParams, ...$sliderMultipleParams });
            } else {
                new Slider($item, $sliderParams);
            }
        });
    }

    initHighContrast() {
        const $highContrast = document.querySelector('.high-contrast');

        if (!$highContrast) {
            return;
        }

        new HighContrast($highContrast);
    }

    initLoginModal() {
        const $loginModal = document.querySelector('.login-modal');

        if (!$loginModal) {
            return;
        }

        new LoginModal($loginModal);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new App(); // eslint-disable-line no-new
});


// WEBPACK FOOTER //
// ./front/treasurybond/js/main.js